<template>
  <div class="home">
    <!--头部start-->
    <daq-header>
      <div class="btn-back" slot="left" @click="returnPrev">
        <span class="ued-mobile">&#xe6b2;</span>返回
      </div>
      <span slot="title">查看图片</span>
      <div slot="right">
        <span class="ued-mobile">&#xe6b3;</span>
      </div>
    </daq-header>
    <ul class="photo-list">
      <li v-for="(item, index) in list" :key="index" @click="showCheckPhoto(index)">
        <img :src="item" :alt="item">
      </li>
    </ul>
    <daq-check-photo :show="show" :list="list" @hide="hideHandler" :initialSlide="initialSlide"></daq-check-photo>
    <!--头部end-->
    <daq-ewm></daq-ewm>
  </div>
</template>
<script>
export default {
  data () {
    return {
      initialSlide: 0,
      show: false,
      list: [
        'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1533112418583&di=b1ac93408f55595b76e17f1d02a7931e&imgtype=0&src=http%3A%2F%2Fpic9.photophoto.cn%2F20081128%2F0033033999061521_b.jpg',
        'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1533112418583&di=b1ac93408f55595b76e17f1d02a7931e&imgtype=0&src=http%3A%2F%2Fpic9.photophoto.cn%2F20081128%2F0033033999061521_b.jpg',
        'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1533112418583&di=b1ac93408f55595b76e17f1d02a7931e&imgtype=0&src=http%3A%2F%2Fpic9.photophoto.cn%2F20081128%2F0033033999061521_b.jpg',
        'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1533112418583&di=b1ac93408f55595b76e17f1d02a7931e&imgtype=0&src=http%3A%2F%2Fpic9.photophoto.cn%2F20081128%2F0033033999061521_b.jpg'
      ]
    }
  },
  methods: {
    returnPrev () {
      this.$router.go(-1)
    },
    // 显示
    showCheckPhoto (index) {
      this.initialSlide = index
      this.show = true
    },
    // 隐藏
    hideHandler () {
      this.show = false
    }
  }
}
</script>

<style lang="scss">
  .photo-list{
    padding:.2rem .2rem 0 .2rem;
    li{
      width:50%;
      height:2.4rem;
      overflow:hidden;
      display:inline-block;
      padding:.1rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/page/checkPhoto.vue